import React, { useMemo } from "react";
import { cn } from "../../styles";
import { LocalizationScope } from "../../util";
import { fieldTypes } from "../../constants";
import FieldSet from "./FieldSet";
import { Typography } from "../../atoms";
import { Panel } from "../../layouts";
import { PanelColor, ThemeColor } from "../../props";

export default function Group({
  className,
  group,
  title = { local: "Title" },
  fields,
  noMargin,
  ...fieldSetProps
}: any) {
  const formFields = useMemo(
    () =>
      fields
        ? fields.filter((f) => {
            if (f.hidden || f.type === fieldTypes.TERMS) return false;
            if (!f.group && !group) return true;
            if (f.group === group) return true;
            return false;
          })
        : [],
    [fields, group]
  );

  if (formFields.length === 0) return null;
  return (
    <Panel
      className={cn(group ? "my-4 p-2" : "my-4 p-0", className)}
      color={group ? PanelColor.level2 : ThemeColor.none}
      border={!!group}
      shadow={!!group}
    >
      {group && (
        <LocalizationScope scope={group}>
          <Typography.P content={title} className="font-medium mb-1" />
        </LocalizationScope>
      )}
      <FieldSet
        {...fieldSetProps}
        fields={formFields}
        className={cn(fieldSetProps.className)}
      />
    </Panel>
  );
}
